import { render, staticRenderFns } from "./UserProfileContainer.vue?vue&type=template&id=2788dc4b&scoped=true"
import script from "./UserProfileContainer.vue?vue&type=script&lang=js"
export * from "./UserProfileContainer.vue?vue&type=script&lang=js"
import style0 from "./UserProfileContainer.vue?vue&type=style&index=0&id=2788dc4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2788dc4b",
  null
  
)

export default component.exports